import { render, staticRenderFns } from "./InstituteView.vue?vue&type=template&id=684016ca&"
import script from "./InstituteView.vue?vue&type=script&lang=js&"
export * from "./InstituteView.vue?vue&type=script&lang=js&"
import style0 from "./InstituteView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports